export default {
  global: {
    ok: "D'acord",
    accept: 'Acceptar',
    continue: 'Continuar',
    cancel: 'Cancel·lar',
    loading: 'Carregant...',
  },
  vinculacioPage: {
    header: 'Vincula el teu\nidCAT Mòbil',
    description:
      "Per començar a utilitzar l'aplicació, identifica't amb el teu idCAT Mòbil. Només ho hauràs de fer una vegada.",
    button: 'Vincula idCAT Mòbil',
  },
  userAlreadyExistsPage: {
    header: 'Aquest idCAT Mòbil ja està en ús en un altre dispositiu',
    description:
      "L'idCAT Mòbil només pot estar vinculat a un dispositiu mòbil. Si decideixes vincular-lo a aquest, es desactivarà al dispositiu anterior.",
  },
  successPage: {
    header: 'Autenticació completada amb èxit',
    description:
      "El document identificatiu s'ha verificat correctament amb idCAT Mòbil.\n Ja pots continuar el procés a la pàgina web del servei",
  },
  onboardingFinish: {
    header: 'idCAT Mòbil vinculat correctament en aquest dispositiu',
    description:
      "A partir d'ara ja et pots identificar amb idCAT Mòbil per accedir als tràmits de les administracions públiques catalanes, escanejant el codi QR o confirmant la sol·licitud d'accés.",
    userFields: {
      name: 'Nom',
      id: 'Document identificatiu',
      phoneNumber: 'Telèfon mòbil',
      device: 'Dispositiu vinculat',
    },
  },
  errors: {
    messageProcessing: {
      title: 'Error en processar el missatge',
      message:
        "No s'ha pogut processar el missatge. Torna-ho a provar o contacta amb suport.",
    },
    invalidRequest: {
      title: 'Petició no vàlida',
      message:
        'Paràmetres de petició no vàlids. Comprova-ho i torna-ho a provar.',
    },
    authenticationFailed: {
      title: 'Autenticació fallida',
      message:
        "El seu intent d'autenticació no ha tingut èxit. Torna-ho a provar o contacta amb suport.",
    },
    accessDenied: {
      title: 'Accés denegat',
      message:
        'No teniu permís per a accedir aquest recurs. Comprova les credencials i torna-ho a provar.',
    },
    connectionError: {
      title: 'Error de connexió',
      message:
        'No es pot connectar al servidor. Comprova la connexió i prova de nou.',
    },
    aocWalletUserError: {
      title: 'Error de connexió',
      message:
        "S'ha produït un error en intentar recuperar l'usuari de la cartera. Torna-ho a provar més tard.",
    },
    generalError: {
      title: 'Error',
      message:
        "S'ha produït un error inesperat. Torna-ho a provar o contacta amb suport.",
    },
  },
};
